// libs
import React, { useMemo } from 'react';

// components
import { Box, BoxProps } from '@lyearn/ui';
// context
import { ContentDetailsContext } from '@/components/ContentDetails/context';
// types
import { ContentDetailsProps } from '@/components/ContentDetails/types';

type Props = ContentDetailsProps & Omit<BoxProps, 'content'>;

const ContentDetails: React.FC<Props> = (props) => {
  const { content, children, ...rest } = props;
  const value = useMemo(() => ({ content }), [content]);

  return (
    <ContentDetailsContext.Provider value={value}>
      <Box {...rest}>{children}</Box>
    </ContentDetailsContext.Provider>
  );
};

export default ContentDetails;
